/**
 * @file Initializes the AWS RUM client used to monitor the app in production.
 */

import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { isLocal } from "@components/Constants";
import { getConfig } from "@components/Config";

const RUM_APP_ID: string = getConfig("RUM_APP_ID");
const RUM_REGION: string = getConfig("RUM_REGION");
const RUM_IDENTITY_POOL_ID: string = getConfig("RUM_IDENTITY_POOL_ID");
const PLATFORM_VERSION: string = getConfig("PLATFORM_VERSION");

let rumClientInstance: AwsRum | null = null;

/**
 * Initializes the AWS RUM client, unless the app is running locally or is missing its configuration.
 */
const initializeRum = (): AwsRum | null => {
  const isDisabled = isLocal || !RUM_APP_ID || !RUM_IDENTITY_POOL_ID;
  if (isDisabled) {
    return null;
  }

  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    identityPoolId: RUM_IDENTITY_POOL_ID,
    endpoint: `https://dataplane.rum.${RUM_REGION}.amazonaws.com`,
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: false,
  };

  rumClientInstance = new AwsRum(RUM_APP_ID, PLATFORM_VERSION, RUM_REGION, config);

  return rumClientInstance;
};

/**
 * Returns the current AWS RUM client instance, when one was initialized.
 */
const getRumClient = (): AwsRum | null => rumClientInstance;

export { getRumClient };
export default initializeRum;
